
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import EmployeesList from './components/EmployeesList';
import EmployeeForm from './components/EmployeeForm';
import PayrollList from './components/PayrollList';
import PayrollForm from './components/PayrollForm';
import PayrollReports from './components/PayrollReports';

export default function EmployeesPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('employees');
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showPayrollForm, setShowPayrollForm] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [selectedEmployeeForPayroll, setSelectedEmployeeForPayroll] = useState(null);
  const navigate = useNavigate();

  const handleAddEmployee = () => {
    setEditingEmployee(null);
    setShowEmployeeForm(true);
  };

  const handleEditEmployee = (employee: any) => {
    setEditingEmployee(employee);
    setShowEmployeeForm(true);
  };

  const handleCloseEmployeeForm = () => {
    setShowEmployeeForm(false);
    setEditingEmployee(null);
  };

  const handleCreatePayroll = (employee: any) => {
    setSelectedEmployeeForPayroll(employee);
    setShowPayrollForm(true);
  };

  const handleClosePayrollForm = () => {
    setShowPayrollForm(false);
    setSelectedEmployeeForPayroll(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 sm:mb-8 flex items-center space-x-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                title="Retour au tableau de bord"
              >
                <i className="ri-arrow-left-line text-xl text-gray-600"></i>
              </button>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Ressources Humaines</h1>
                <p className="text-sm sm:text-base text-gray-600">Gestion des employés et de la paie</p>
              </div>
            </div>

            {/* Onglets de navigation */}
            {!showEmployeeForm && !showPayrollForm && (
              <div className="mb-4 sm:mb-6">
                <div className="border-b border-gray-200 overflow-x-auto">
                  <nav className="-mb-px flex space-x-4 sm:space-x-8 min-w-max">
                    <button
                      onClick={() => setActiveTab('employees')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'employees'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-team-line"></i>
                      <span>Personnel</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('payroll')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'payroll'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-money-dollar-circle-line"></i>
                      <span>Salaires</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('reports')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'reports'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-file-chart-line"></i>
                      <span>Rapports</span>
                    </button>
                  </nav>
                </div>
              </div>
            )}

            {showPayrollForm ? (
              <PayrollForm 
                employee={selectedEmployeeForPayroll}
                onClose={handleClosePayrollForm}
              />
            ) : showEmployeeForm ? (
              <EmployeeForm 
                employee={editingEmployee}
                onClose={handleCloseEmployeeForm}
              />
            ) : (
              <>
                {activeTab === 'employees' && (
                  <EmployeesList 
                    onEdit={handleEditEmployee}
                    onAdd={handleAddEmployee}
                    onCreatePayroll={handleCreatePayroll}
                  />
                )}
                {activeTab === 'payroll' && (
                  <PayrollList 
                    onCreatePayroll={handleCreatePayroll}
                  />
                )}
                {activeTab === 'reports' && (
                  <PayrollReports />
                )}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
